import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {Observable, of as observableOf} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';

import {IngenieroAgronomoService} from "../../../../../chacra-core";
import * as ingenierosAgronomosActions from './ingenieros-agronomos.actions';
import {AUTH_ROLE_ID} from "../../../../../core/models";
import {LocalStorageService} from "../../../../../core";

@Injectable()
export class IngenierosAgronomosEffects {
  IngenierosAgronomosLoadRequestEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<ingenierosAgronomosActions.IngenierosAgronomosLoadRequestAction>(
      ingenierosAgronomosActions.IngenierosAgronomosActionTypes.INGENIEROSAGRONOMOS_LOAD_REQUEST
    ),
    switchMap(() => {
      const rolId = this.localStorageService.getItem(AUTH_ROLE_ID);
      return this.ingenierosAgronomosCoreService.get().pipe(
        map(queryResult => {
          return new ingenierosAgronomosActions.IngenierosAgronomosLoadSuccessAction(
            {
              items: queryResult.items
            }
          );
        }),
        catchError(error =>
          observableOf(
            new ingenierosAgronomosActions.IngenierosAgronomosLoadFailureAction(
              {
                error
              }
            )
          )
        )
      );
    })
  ));

  // load

  constructor(
    private ingenierosAgronomosCoreService: IngenieroAgronomoService,
    private actions$: Actions,
    private localStorageService: LocalStorageService
  ) {
  }
}
